function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var R = 6371; // Radius of the earth in km
var LocationSortingManager = /*#__PURE__*/function () {
  function LocationSortingManager() {
    _classCallCheck(this, LocationSortingManager);
  }
  return _createClass(LocationSortingManager, [{
    key: "sort",
    value:
    /**
     * @param {Location[]} locations
     * @param {Location} targetLocation
     * @returns {Location[]}
     */
    function sort(locations, targetLocation) {
      var measuredLocations = locations.map(function (location) {
        location.Distance = LocationSortingManager.getDistanceFromLatLngInKm(location, targetLocation);
        return location;
      });
      return measuredLocations.sort(function (locationA, locationB) {
        if (locationA.Distance < locationB.Distance) return -1;
        if (locationA.Distance > locationB.Distance) return 1;
        return 0;
      });
    }

    /**
     * @param {Location} location1
     * @param {Location} location2
     * @private
     * @returns {number}
     */
  }], [{
    key: "getDistanceFromLatLngInKm",
    value: function getDistanceFromLatLngInKm(location1, location2) {
      var lat1 = location1.lat;
      var lng1 = location1.lng;
      var lat2 = location2.lat;
      var lng2 = location2.lng;
      var dLat = LocationSortingManager.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = LocationSortingManager.deg2rad(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    }

    /**
     * @param {number} deg
     * @private
     * @returns {number}
     */
  }, {
    key: "deg2rad",
    value: function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
  }]);
}();
export default LocationSortingManager;